import { Tooltip, TooltipContent, TooltipTrigger } from '@/platform/ui';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

const BooleanIcon = ({ positive }) => (
    <Tooltip>
        <TooltipTrigger>
            {positive ? (
                <CheckCircleIcon className='size-5 text-green-500' />
            ) : (
                <XCircleIcon className='size-5 text-red-500' />
            )}
        </TooltipTrigger>
        <TooltipContent>{positive ? 'Ja' : 'Nee'}</TooltipContent>
    </Tooltip>
);

export default BooleanIcon;
